export const translations = {
  en: {
    navbar: {
      myTrips: 'My Trips',
      favorites: 'Favorites',
      bookings: 'Booking History',
      profile: 'My Profile',
      faq: "Traveler's Guide",
      logout: 'Logout',
      login: 'Login / Sign Up',
      mySubscription: 'My Subscription',
      confirmLogout: {
        title: 'Confirm Logout',
        message: 'Are you sure you want to log out?'
      }
    },
    pages: {
      myTrips: {
        title: 'My Trips',
        noTrips: 'You haven\'t created any trips yet.',
        loading: 'Loading your trips...',
        createNew: 'Create New Trip',
        expired: 'Expired',
        lastUpdated: 'Last updated',
        previous: 'Previous',
        next: 'Next',
        status: {
          expired: 'expired',
          upcoming: 'upcoming',
          active: 'active'
        },
        settings: {
          title: 'Trip Settings',
          delete: 'Delete',
          clone: 'Copy',
          save: 'Save',
          cancel: 'Cancel',
          confirmDelete: 'Are you sure you want to delete this trip?',
          tripName: 'Trip Name',
          dates: 'Trip Dates',
          deleteSuccess: 'Trip deleted successfully',
          deleteError: 'Failed to delete trip',
          updateSuccess: 'Trip updated successfully',
          updateError: 'Failed to update trip',
          cloneSuccess: 'Trip copied successfully',
          cloneError: 'Failed to copy trip',
          createSuccess: 'Trip created successfully',
          createError: 'Failed to create trip',
          makePublic: 'Make trip public',
          dateFormat: {
            month: 'MMM',
            monthDay: 'MMM d'
          }
        }
      },
      tours: {
        title: 'Explore Our Tours',
        loading: 'Loading...',
        noResults: 'No tours or itineraries available with the selected filters.',
        filters: {
          guidedTours: 'Guided Tours',
          selfGuided: 'Self-Guided'
        },
        cardTypes: {
          guidedTour: 'Guided Tour',
          selfGuided: 'Self-Guided'
        },
        operatorTag: 'By',
        operator: {
          title: 'Tour Operator Profile',
          availableTours: 'Available Tours',
          notFound: 'Operator not found',
          noTours: 'No tours available',
          landingPage: {
            title: 'Become a Partner Tour Operator',
            subtitle: 'Join our platform and grow your tourism business',
            benefits: {
              customers: {
                title: 'Reach More Customers',
                description: 'Connect with travelers looking for authentic experiences'
              },
              revenue: {
                title: 'Increase Revenue',
                description: 'Boost your bookings and maximize your earnings'
              },
              management: {
                title: 'Easy Management',
                description: 'Manage your tours and bookings with our intuitive tools'
              },
              payments: {
                title: 'Secure Payments',
                description: 'Receive payments securely and on time'
              }
            },
            whyUs: {
              title: 'Why Choose Us?',
              features: [
                'Access to a growing community of travelers',
                'Professional booking management system',
                'Marketing and promotion support',
                'Real-time analytics and insights',
                'Dedicated customer support'
              ]
            },
            form: {
              title: 'Get Started Today',
              subtitle: 'Fill out the form below and we\'ll get in touch with you',
              businessName: 'Business Name',
              email: 'Email Address',
              phone: 'Phone Number',
              description: 'Tell us about your business',
              submit: 'Submit Request',
              success: 'Thank you for your interest! We\'ll contact you soon.',
              error: 'Something went wrong. Please try again.',
              emailExists: 'An operator with this email already exists',
              validation: {
                nameRequired: 'Business name is required',
                emailRequired: 'Email is required',
                emailInvalid: 'Please enter a valid email',
                phoneInvalid: 'Please enter a valid phone number'
              }
            }
          },
          tourManagement: {
            backToDashboard: 'Back to Dashboard',
            tourNotFound: 'Tour not found',
            loading: 'Loading...',
            details: 'Additional Details',
            included: "What's Included",
            notIncluded: "What's Not Included",
            tips: 'Tips for Travelers',
            dates: {
              title: 'Available Dates',
              addDate: 'Add Date',
              editDate: 'Edit Date',
              date: 'Date',
              stock: 'Stock',
              actions: 'Actions',
              noDates: 'No dates added yet. Click "Add Date" to start adding available dates.',
              rowsPerPage: 'Rows per page:',
              page: 'Page',
              of: 'of',
              currentStock: 'Current Stock',
              totalStock: 'Total Stock',
              downloadParticipants: 'Download Participants List',
              manageParticipants: 'Manage Participants',
              spotLeft: 'spot left',
              spotsLeft: 'spots left',
              bookedAt: 'Booked at',
              available: 'Available',
              participants: 'participants',
              noParticipantsYet: 'No participants yet',
              platformBookings: 'Platform Bookings',
              spot: 'spot',
              spots: 'spots',
              menuOptions: {
                addParticipant: 'Add Participant',
                downloadList: 'Download Participants List',
                editDate: 'Edit Date'
              }
            },
            participants: {
              title: 'Participants',
              firstName: 'First Name',
              lastName: 'Last Name',
              email: 'Email',
              phone: 'Phone',
              addParticipant: 'Add Participant',
              editParticipant: 'Edit Participant',
              registeredUser: 'Platform User',
              noParticipants: 'No participants added yet.',
              save: 'Save',
              cancel: 'Cancel'
            },
            notifications: {
              dateAdded: 'Date added successfully',
              dateAddError: 'Failed to add date',
              dateUpdated: 'Date updated successfully',
              dateUpdateError: 'Failed to update date',
              dateDeleted: 'Date deleted successfully',
              dateDeleteError: 'Failed to delete date',
              participantAdded: 'Participant added successfully',
              participantAddError: 'Failed to add participant',
              participantUpdated: 'Participant updated successfully',
              participantUpdateError: 'Failed to update participant',
              participantDeleted: 'Participant deleted successfully',
              participantDeleteError: 'Failed to delete participant',
              loadError: 'Failed to load tour data',
              tourUpdated: 'Tour updated successfully'
            }
          },
          tourForm: {
            createTitle: 'Create New Tour',
            editTitle: 'Edit Tour',
            backToDashboard: 'Back to Dashboard',
            tourName: 'Tour Name',
            description: 'Description',
            stockLimit: 'Stock Limit',
            price: 'Price',
            recurringTour: 'Recurring Tour',
            availableDates: 'Available Dates',
            addDate: 'Add Date',
            date: 'Date',
            stock: 'Stock',
            actions: 'Actions',
            noDates: 'No dates added yet. Click "Add Date" to start adding available dates.',
            tourDate: 'Tour Date',
            included: "What's Included",
            notIncluded: "What's Not Included",
            meetingPoint: 'Meeting Point',
            tips: 'Tips for Travelers',
            makePublic: 'Make Tour Public',
            createButton: 'Create Tour',
            updateButton: 'Update Tour',
            cancel: 'Cancel',
            notifications: {
              createSuccess: 'Tour created successfully',
              createError: 'Failed to save tour',
              updateSuccess: 'Tour updated successfully',
              updateError: 'Failed to update tour',
              loadError: 'Failed to load tour data',
              imageUploadError: 'Failed to upload image',
                              imageSizeError: 'Some images exceed the 5MB limit. Please choose smaller images.',
              maxImagesError: 'Maximum {max} images allowed',
              imageUploadSuccess: 'Images uploaded successfully',
              imageRemoveSuccess: 'Image removed successfully'
            },
            tourImages: 'Tour Images',
            uploadImages: 'Upload Images',
            images: 'images',
            maxImageSize: 'Maximum 5MB per image',
            validation: {
              nameRequired: 'Tour name is required',
              descriptionRequired: 'Description is required for public tours',
              stockRequired: 'Stock limit is required for public tours',
              priceRequired: 'Price is required for public tours',
              meetingPointRequired: 'Meeting point is required for public tours',
              includedRequired: 'At least one included item is required for public tours',
              notIncludedRequired: 'At least one not included item is required for public tours',
              tourDateRequired: 'Tour date is required for public tours',
              availableDatesRequired: 'At least one available date is required for public tours',
              imagesRequired: 'At least one image is required for public tours',
              fixErrors: 'Please fix the errors before saving',
              cannotMakePublic: 'Please fill in all required fields before making the tour public'
            }
          },
          dashboard: {
            myTours: 'My Tours',
            createNewTour: 'Create New Tour',
            paymentHistory: 'Payment History',
            backToDashboard: 'Back to Dashboard',
            editProfile: 'Edit Profile',
            uploadPhoto: 'Upload Photo',
            businessName: 'Business Name',
            phone: 'Phone',
            description: 'Description',
            saveChanges: 'Save Changes',
            cancel: 'Cancel',
            deleteTour: {
              title: 'Delete Tour',
              message: 'Are you sure you want to delete this tour? This action cannot be undone and all information associated with this tour will be permanently lost.',
              confirm: 'Delete Tour',
              cancel: 'Cancel'
            },
            tourVisibility: {
              public: 'Tour is public',
              private: 'Tour is private'
            },
            tourDates: {
              dates: 'dates',
              date: 'fecha'
            },
            notifications: {
              profileUpdateSuccess: 'Profile updated successfully',
              profileUpdateError: 'Failed to update profile',
              tourDeleteSuccess: 'Tour deleted successfully',
              tourDeleteError: 'Failed to delete tour',
              tourVisibilitySuccess: 'Tour visibility updated',
              tourVisibilityError: 'Failed to update tour visibility',
              loadError: {
                profile: 'Failed to load profile',
                tours: 'Failed to load tours',
                reports: 'Failed to load payment reports',
                reportDetails: 'Failed to load report details'
              },
              imageUploadError: 'Error al subir la imagen',
              maxImagesError: 'Máximo {max} imágenes permitidas',
              imageUploadSuccess: 'Imágenes subidas exitosamente',
              imageRemoveSuccess: 'Imagen eliminada exitosamente'
            },
            paymentTable: {
              date: 'Date',
              transactions: 'Transactions',
              duePayment: 'Due Payment',
              status: 'Status',
              actions: 'Actions',
              viewDetails: 'View Details',
              processed: 'Processed',
              pending: 'Pending'
            },
            paymentDetails: {
              title: 'Payment Report Details',
              customer: 'Customer',
              tour: 'Tour',
              tourDate: 'Tour Date',
              bookingDate: 'Booking Date',
              amount: 'Amount',
              status: 'Status',
              summary: {
                totalAmount: 'Total Amount',
                managementFee: 'Management Fee (10%)',
                duePayment: 'Due Payment'
              }
            }
          }
        }
      },
      publicItinerary: {
        scheduleTrip: 'Schedule Trip',
        createNewTrip: '＋ Create New Trip',
        tripOverview: 'Trip Overview',
        showMore: 'Show more',
        showLess: 'Show less',
        processingSubscription: 'Processing your subscription...'
      },
      tourModal: {
        selectDate: 'Select a date',
        bookTour: 'Book Tour',
        included: "What's Included",
        notIncluded: 'Not Included',
        tips: 'Tips',
        meetingPoint: 'Meeting Point',
        spotsLeft: 'spots left',
        spotLeft: 'spot left',
        noSpots: 'No spots available',
        showMore: 'Show more',
        showLess: 'Show less',
        chooseDatePlaceholder: 'Choose a date',
        noAvailableDates: 'No available dates for this tour',
        soldOut: 'SOLD OUT',
        completePayment: 'Complete Your Payment'
      },
      profile: {
        title: 'My Profile',
        personalInfo: 'Personal Information',
        loading: 'Loading profile...',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        country: 'Country',
        locationNotSet: 'Location not set',
        changePassword: 'Change Password',
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm New Password',
        passwordError: {
          mismatch: 'New passwords do not match',
          length: 'New password must be at least 6 characters long',
          same: 'New password must be different from current password',
          generic: 'Error changing password'
        },
        updateSuccess: 'Profile updated successfully',
        updateError: 'Error updating profile',
        passwordSuccess: 'Password updated successfully',
        saveChanges: 'Save Changes',
        cancel: 'Cancel',
        edit: 'Edit',
        stats: {
          title: 'Travel Statistics',
          totalTrips: 'Total Trips',
          placesVisited: 'Places Visited',
          hotelsBooked: 'Hotels Booked'
        },
        quickLinks: {
          favorites: 'Favorites',
          bookings: 'Bookings',
          subscription: 'Subscription',
          changePassword: 'Change Password'
        }
      },
      bookings: {
        title: 'Booking History',
        noBookings: 'No bookings found',
        loading: 'Loading bookings...'
      },
      favorites: {
        title: 'My Favorites',
        noFavorites: 'No favorites yet',
        loading: 'Loading favorites...'
      },
      tripDetails: {
        loading: 'Loading...',
        title: 'Trip Details',
        budget: 'Budget',
        checklist: 'Checklist',
        share: {
          title: 'Share Trip',
          whatsapp: 'Share on WhatsApp',
          twitter: 'Share on X',
          email: 'Share via Email',
          copy: 'Copy link',
          privateMessage: 'Trips are private by default, make it public in your trip settings.'
        },
        confirmDelete: {
          title: 'Confirm Delete',
          message: 'Are you sure you want to delete this trip?',
          cancel: 'Cancel',
          confirm: 'Delete'
        },
        confirmDeletePOI: {
          title: 'Delete {type}',
          message: 'Are you sure you want to delete "{name}"?',
          cancel: 'Cancel',
          confirm: 'Delete'
        },
        unsavedChanges: {
          title: 'Save Changes?',
          message: 'Do you want to save the changes you made?',
          cancel: 'Cancel',
          confirm: 'Save'
        },
        toast: {
          titleUpdated: 'Title updated successfully',
          titleError: 'Failed to update title. Please try again.',
          activityDateUpdated: 'Activity date updated successfully',
          activityDateError: 'Failed to update activity date. Please try again.',
          activityAdded: 'Activity added to trip successfully!',
          activityAddError: 'Failed to add activity to trip. Please try again.'
        }
      },
      subscription: {
        title: 'Choose Your Plan',
        free: {
          title: 'Free',
          price: '$0',
          perMonth: '/month'
        },
        premium: {
          title: 'Premium',
          price: '$4.99',
          perMonth: '/month',
          upgradeButton: 'Upgrade to Premium',
          currentPlan: 'Current Plan',
          completeSubscription: 'Complete Your Subscription'
        },
        features: {
          allFreeFeatures: 'All free features',
          unlimitedTrips: 'Create unlimited active trips',
          adFree: 'Ad-free experience',
          advancedBudget: 'Trip budget with advanced features',
          offlineMaps: 'Offline maps and trekking routes',
          noBookingFees: 'No booking fees for recommended hotels',
          liveChat: 'Live chat with locals',
          curated: 'Access to our curated list of exclusive places to visit',
          faq: 'Access to our FAQ and country information',
          budget: 'Trip budget overview',
          customActivities: 'Creation of custom activities for your trip itinerary',
          hotelBookings: 'Recomended hotel bookings (with a fee)',
          shareTrips: 'Share your trips',
          weather: 'Weather forecast for the day',
          language: 'English and Spanish support'
        },
        status: {
          title: 'Subscription Status: Premium',
          missingId: 'Your subscription ID is missing. This might happen if you\'ve recently upgraded.',
          currentId: 'Current subscription ID:',
          tryLogout: 'Please try logging out and back in, or contact support if the issue persists.'
        }
      },
      faq: {
        title: 'Frequently Asked Questions',
        subtitle: 'Find answers to common questions about our services, booking process, and more.',
        searchPlaceholder: 'Search FAQs...',
        loading: 'Loading...',
        noResults: 'No FAQs found matching your search.',
        error: 'Error: ',
        showMore: 'Show More'
      }
    },
    components: {
      tourModal: {
        selectDate: 'Select a date',
        bookTour: 'Book Tour',
        included: "What's Included",
        notIncluded: 'Not Included',
        tips: 'Tips',
        meetingPoint: 'Meeting Point',
        spotsLeft: 'spots left',
        spotLeft: 'spot left',
        noSpots: 'No spots available',
        showMore: 'Show more',
        showLess: 'Show less',
        chooseDatePlaceholder: 'Choose a date',
        noAvailableDates: 'No available dates for this tour',
        soldOut: 'SOLD OUT',
        completePayment: 'Complete Your Payment'
      }
    },
    poi: {
      showMore: 'Show more',
      showLess: 'Show less',
      addToTrip: 'Add to Trip',
      addToFavorites: 'Add to Favorites',
      removeFromFavorites: 'Remove from Favorites',
      share: 'Share',
      recommendedHotels: 'Recommended Hotels',
      amenities: 'Amenities',
      address: 'Address',
      contact: 'Contact',
      phone: 'Phone',
      email: 'Email',
      bookNow: 'Book Now',
      pricePerNight: 'per night',
      seeMoreDetails: 'See more details',
      seeLessDetails: 'See less details',
      includesBookingFees: 'Price includes booking fees and taxes',
      backToPoi: 'Back to',
      addToTripSuccess: 'POI added to trip successfully!',
      addToTripError: 'Error adding POI to trip. Please try again.',
      alreadyInTrip: 'This POI is already in the selected trip.',
      rooms: {
        availableRooms: 'Available Rooms',
        maxGuests: 'Max guests',
        adults: 'adults',
        perNight: 'per night',
        beds: 'bed',
        beds_plural: 'beds',
        seeMoreDetails: 'See more details',
        seeLessDetails: 'See less details',
        showLessAmenities: 'Show less',
        showMoreAmenities: '...',
      },
      hotelDetails: {
        amenities: 'Amenities',
        address: 'Address',
        contact: 'Contact',
        phone: 'Phone',
        email: 'Email',
      },
      recommendedHotels: 'Recommended Hotels',
      viewDetails: 'View Details',
      nearbyHotels: 'Nearby Hotels',
      nearbyPlaces: 'Nearby Places',
      viewOnMap: 'View on Map',
      howToGet: 'How to get there',
      noDirections: 'No information available on how to get here.'
    },
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      retry: 'Retry',
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      update: 'Update',
      yes: 'Yes',
      no: 'No',
      locale: 'en'
    },
    hotelBooking: {
      guestInfo: 'Guest Information',
      guest: 'Guest',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      addToTrip: 'Add to Trip',
      createNewTrip: 'Create New Trip',
      selectTrip: 'Select Trip',
      tripDates: 'Trip Dates',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      numberOfGuests: 'Number of Guests',
      bookingSummary: 'Booking Summary',
      roomType: 'Room Type',
      totalAmount: 'Total Amount',
      bookingFee: 'Booking Fee',
      taxes: 'Taxes',
      total: 'Total',
      paymentDetails: 'Complete Your Booking',
      premiumDiscount: 'As a premium member, you can complete your booking without any booking fees.',
      upgradeForDiscount: 'Upgrade to Premium for 10% off',
      upgradeToPremium: 'Upgrade to Premium',
      proceedToPayment: 'Complete Booking',
      back: 'Back',
      next: 'Next',
      sameAsTripDates: 'Will you stay at this hotel for the entire trip?',
      bookingSuccess: 'Booking Successful!',
      viewBooking: 'View Booking',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      invalidPhone: 'Invalid phone number',
      selectTripFirst: 'Please select a trip first',
      guestCountError: 'The number of guests exceeds the maximum capacity for the selected rooms. Please add more rooms.',
      termsAgreement: 'I understand that the booking fee is non-refundable and I agree to Quisqueya Quest\'s',
      termsOfService: 'terms of service',
      bookingFeeMessage: 'Please complete your payment to confirm your booking. You will be charged',
      dueAtPropertyMessage: 'The remaining amount will be paid at the property',
      loadingPayment: 'Loading PayPal...',
      paymentWindowError: 'Payment window already open',
      paypalError: 'Error loading PayPal. Please refresh the page and try again.',
      processingBooking: 'Processing your booking...',
      paymentWindowClosed: 'Payment window was closed. Please try again.',
      tripTo: 'Trip to',
      checkInAt: 'Check-in at',
      checkOutFrom: 'Check-out from',
      dueAtProperty: 'Due at Property'
    },
    auth: {
      welcomeBack: "Welcome Back",
      createAccount: "Create Your Account",
      signIn: "Sign In",
      signUp: "Sign Up",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      password: "Password",
      noAccount: "Don't have an account? Sign up",
      haveAccount: "Already have an account? Sign in",
      forgotPassword: "Forgot password?",
      forgotPasswordMailSubject: "Temporary password request — Quisqueya Quest",
      forgotPasswordMailBody:
        "Hello,\n\nI would like to request a temporary password for my Quisqueya Quest account.\n\nThank you.",
      close: "Close",
      errors: {
        default: "An unexpected error occurred. Please try again.",
        invalidCredentials: "Invalid email or password",
        emailExists: "An account with this email already exists",
        required: "This field is required",
        invalidEmail: "Please enter a valid email address"
      }
    },
    customActivity: {
      title: 'Create Custom Activity',
      editTitle: 'Edit Activity',
      activityDetails: 'Activity Details',
      name: 'Name',
      type: 'Type',
      description: 'Description',
      duration: 'Duration',
      hours: 'hour(s)',
      location: 'Location',
      addLocation: 'Add a location?',
      price: 'Price',
      optional: 'optional',
      saveChanges: 'Save Changes',
      saveActivity: 'Save Activity',
      types: {
        task: 'Task',
        hotel: 'Hotel',
        exploration: 'Exploration',
        rent_a_car: 'Rent a Car',
        restaurant: 'Restaurant',
        poi: 'Point of Interest',
        select: 'Select activity type'
      },
      validation: {
        nameRequired: 'Name is required',
        typeRequired: 'Activity type is required'
      },
      updateSuccess: 'Activity updated successfully',
      updateError: 'Failed to update activity'
    },
    budget: {
      title: 'Trip Budget',
      overview: 'Overview',
      advancedSettings: 'Advanced Settings',
      totalBudget: 'Total Budget',
      budgetAlerts: 'Budget Alerts',
      selectDay: 'Select Day',
      selectType: 'Select Activity Type',
      limit: 'Limit',
      set: 'Set',
      delete: 'Delete',
      confirmDelete: {
        title: 'Delete Budget Limit',
        message: 'Are you sure you want to delete this budget limit?'
      },
      premiumFeature: {
        title: 'Budget alerts are a premium feature',
        upgrade: 'Upgrade to Premium'
      },
      includes: 'Price includes booking fees and taxes'
    },
    checklist: {
      title: 'Trip Checklist',
      addNew: 'Add new item',
      deleteConfirm: {
        title: 'Delete Checklist Item',
        message: 'Are you sure you want to delete this item?'
      },
      defaultItems: {
        passport: 'Passport and tourist card',
        sunscreen: 'Sunscreen and mosquito repellent',
        beach: 'Beach essentials (swimwear, towels)',
        shoes: 'Comfortable walking shoes',
        money: 'Cash and credit cards'
      }
    },
    subscription: {
      title: 'Choose Your Plan',
      free: {
        title: 'Free',
        price: '$0',
        perMonth: '/month'
      },
      premium: {
        title: 'Premium',
        price: '$4.99',
        perMonth: '/month',
        upgradeButton: 'Upgrade to Premium',
        currentPlan: 'Current Plan',
        completeSubscription: 'Complete Your Subscription'
      },
      features: {
        allFreeFeatures: 'All free features',
        unlimitedTrips: 'Create unlimited active trips',
        adFree: 'Ad-free experience',
        advancedBudget: 'Trip budget with advanced features',
        offlineMaps: 'Offline maps and trekking routes',
        noBookingFees: 'No booking fees for recommended hotels',
        liveChat: 'Live chat with locals',
        curated: 'Access to our curated list of exclusive places to visit',
        faq: 'Access to our FAQ and country information',
        budget: 'Trip budget overview',
        customActivities: 'Creation of custom activities for your trip itinerary',
        hotelBookings: 'Recomended hotel bookings (with a fee)',
        shareTrips: 'Share your trips',
        weather: 'Weather forecast for the day',
        language: 'English and Spanish support'
      },
      status: {
        title: 'Subscription Status: Premium',
        missingId: 'Your subscription ID is missing. This might happen if you\'ve recently upgraded.',
        currentId: 'Current subscription ID:',
        tryLogout: 'Please try logging out and back in, or contact support if the issue persists.'
      }
    },
    faq: {
      title: "Traveler's Guide",
      subtitle: 'Everything you need to know for your Dominican Republic adventure.',
      searchPlaceholder: 'Search travel guide...',
      loading: 'Loading...',
      noResults: 'No guide content found matching your search.',
      error: 'Error: ',
      showMore: 'Show More'
    }
  },
  es: {
    navbar: {
      myTrips: 'Mis Viajes',
      favorites: 'Favoritos',
      bookings: 'Historial de Reservas',
      profile: 'Mi Perfil',
      faq: 'Guía del Viajero',
      logout: 'Cerrar Sesión',
      login: 'Iniciar Sesión / Registrarse',
      mySubscription: 'Mi Suscripción',
      confirmLogout: {
        title: 'Confirmar Cierre de Sesión',
        message: '¿Está seguro que desea cerrar sesión?'
      }
    },
    pages: {
      myTrips: {
        title: 'Mis Viajes',
        noTrips: 'Aún no has creado ningún viaje.',
        loading: 'Cargando tus viajes...',
        createNew: 'Crear Nuevo Viaje',
        expired: 'Expirado',
        lastUpdated: 'Última actualización',
        previous: 'Anterior',
        next: 'Siguiente',
        status: {
          expired: 'expirado',
          upcoming: 'próximo',
          active: 'activo'
        },
        settings: {
          title: 'Configuración',
          delete: 'Eliminar',
          clone: 'Copiar',
          save: 'Guardar',
          cancel: 'Cancelar',
          confirmDelete: '¿Estás seguro de que quieres eliminar este viaje?',
          tripName: 'Nombre del Viaje',
          dates: 'Fechas del Viaje',
          deleteSuccess: 'Viaje eliminado exitosamente',
          deleteError: 'Error al eliminar el viaje',
          updateSuccess: 'Viaje actualizado exitosamente',
          updateError: 'Error al actualizar el viaje',
          cloneSuccess: 'Viaje copiado exitosamente',
          cloneError: 'Error al copiar el viaje',
          createSuccess: 'Viaje creado exitosamente',
          createError: 'Error al crear el viaje',
          makePublic: 'Hacer viaje público',
          dateFormat: {
            month: 'MMM',
            monthDay: 'MMM d'
          }
        }
      },
      tours: {
        title: 'Explora Nuestros Tours',
        loading: 'Cargando...',
        noResults: 'No hay tours o rutas disponibles con los filtros seleccionados.',
        filters: {
          guidedTours: 'Tours Guiados',
          selfGuided: 'Auto-Guiados'
        },
        cardTypes: {
          guidedTour: 'Tour Guiado',
          selfGuided: 'Auto-Guiado'
        },
        operatorTag: 'Por',
        operator: {
          title: 'Perfil del Operador',
          availableTours: 'Tours Disponibles',
          notFound: 'Operador no encontrado',
          noTours: 'No hay tours disponibles',
          landingPage: {
            title: 'Conviértete en Operador Turístico Asociado',
            subtitle: 'Únete a nuestra plataforma y haz crecer tu negocio turístico',
            benefits: {
              customers: {
                title: 'Alcanza Más Clientes',
                description: 'Conéctate con viajeros que buscan experiencias auténticas'
              },
              revenue: {
                title: 'Aumenta tus Ingresos',
                description: 'Impulsa tus reservas y maximiza tus ganancias'
              },
              management: {
                title: 'Gestión Sencilla',
                description: 'Administra tus tours y reservas con nuestras herramientas intuitivas'
              },
              payments: {
                title: 'Pagos Seguros',
                description: 'Recibe pagos de forma segura y puntual'
              }
            },
            whyUs: {
              title: '¿Por Qué Elegirnos?',
              features: [
                'Acceso a una comunidad creciente de viajeros',
                'Sistema profesional de gestión de reservas',
                'Soporte de marketing y promoción',
                'Análisis e información en tiempo real',
                'Soporte dedicado al cliente'
              ]
            },
            form: {
              title: 'Comienza Hoy',
              subtitle: 'Completa el formulario a continuación y nos pondremos en contacto contigo',
              businessName: 'Nombre del Negocio',
              email: 'Correo Electrónico',
              phone: 'Número de Teléfono',
              description: 'Cuéntanos sobre tu negocio',
              submit: 'Enviar Solicitud',
              success: '¡Gracias por tu interés! Te contactaremos pronto.',
              error: 'Algo salió mal. Por favor, inténtalo de nuevo.',
              emailExists: 'Ya existe un operador con este correo electrónico',
              validation: {
                nameRequired: 'El nombre del negocio es requerido',
                emailRequired: 'El correo electrónico es requerido',
                emailInvalid: 'Por favor, ingresa un correo electrónico válido',
                phoneInvalid: 'Por favor, ingresa un número de teléfono válido'
              }
            }
          },
          tourManagement: {
            backToDashboard: 'Volver al Panel',
            tourNotFound: 'Tour no encontrado',
            loading: 'Cargando...',
            details: 'Detalles Adicionales',
            included: 'Qué Incluye',
            notIncluded: 'Qué No Incluye',
            tips: 'Consejos para Viajeros',
            dates: {
              title: 'Fechas Disponibles',
              addDate: 'Agregar Fecha',
              editDate: 'Editar Fecha',
              date: 'Fecha',
              stock: 'Cupos',
              actions: 'Acciones',
              noDates: 'No hay fechas agregadas aún. Haz clic en "Agregar Fecha" para comenzar a agregar fechas disponibles.',
              rowsPerPage: 'Filas por página:',
              page: 'Página',
              of: 'de',
              currentStock: 'Cupos Disponibles',
              totalStock: 'Cupos Totales',
              downloadParticipants: 'Descargar Lista de Participantes',
              manageParticipants: 'Gestionar Participantes',
              spotLeft: 'cupo disponible',
              spotsLeft: 'cupos disponibles',
              bookedAt: 'Reservado el',
              available: 'Disponible',
              participants: 'participantes',
              noParticipantsYet: 'No hay participantes aún',
              platformBookings: 'Reservas de la Plataforma',
              spot: 'cupo',
              spots: 'cupos',
              menuOptions: {
                addParticipant: 'Agregar Participante',
                downloadList: 'Descargar Lista de Participantes',
                editDate: 'Editar Fecha'
              }
            },
            participants: {
              title: 'Participantes',
              firstName: 'Nombre',
              lastName: 'Apellido',
              email: 'Correo Electrónico',
              phone: 'Teléfono',
              addParticipant: 'Agregar Participante',
              editParticipant: 'Editar Participante',
              registeredUser: 'Usuario de Plataforma',
              noParticipants: 'No hay participantes agregados aún.',
              save: 'Guardar',
              cancel: 'Cancelar'
            },
            notifications: {
              dateAdded: 'Fecha agregada exitosamente',
              dateAddError: 'Error al agregar fecha',
              dateUpdated: 'Fecha actualizada exitosamente',
              dateUpdateError: 'Error al actualizar fecha',
              dateDeleted: 'Fecha eliminada exitosamente',
              dateDeleteError: 'Error al eliminar fecha',
              participantAdded: 'Participante agregado exitosamente',
              participantAddError: 'Error al agregar participante',
              participantUpdated: 'Participante actualizado exitosamente',
              participantUpdateError: 'Error al actualizar participante',
              participantDeleted: 'Participante eliminado exitosamente',
              participantDeleteError: 'Error al eliminar participante',
              loadError: 'Failed to load tour data',
              tourUpdated: 'Tour actualizado exitosamente'
            }
          },
          tourForm: {
            createTitle: 'Crear Nuevo Tour',
            editTitle: 'Editar Tour',
            backToDashboard: 'Volver al Panel',
            tourName: 'Nombre del Tour',
            description: 'Descripción',
            stockLimit: 'Límite de Cupos',
            price: 'Precio',
            recurringTour: 'Tour Recurrente',
            availableDates: 'Fechas Disponibles',
            addDate: 'Agregar Fecha',
            date: 'Fecha',
            stock: 'Cupos',
            actions: 'Acciones',
            noDates: 'No hay fechas agregadas aún. Haz clic en "Agregar Fecha" para comenzar a agregar fechas disponibles.',
            tourDate: 'Fecha del Tour',
            included: 'Qué Incluye',
            notIncluded: 'Qué No Incluye',
            meetingPoint: 'Punto de Encuentro',
            tips: 'Consejos para Viajeros',
            makePublic: 'Hacer Tour Público',
            createButton: 'Crear Tour',
            updateButton: 'Actualizar Tour',
            cancel: 'Cancelar',
            notifications: {
              createSuccess: 'Tour creado exitosamente',
              createError: 'Error al guardar el tour',
              updateSuccess: 'Tour actualizado exitosamente',
              updateError: 'Error al actualizar el tour',
              loadError: 'Error al cargar datos del tour',
              imageUploadError: 'Error al subir la imagen',
                              imageSizeError: 'Algunas imágenes exceden el límite de 5MB. Por favor, elija imágenes más pequeñas.',
              maxImagesError: 'Máximo {max} imágenes permitidas',
              imageUploadSuccess: 'Imágenes subidas exitosamente',
              imageRemoveSuccess: 'Imagen eliminada exitosamente'
            },
            tourImages: 'Imágenes del Tour',
            uploadImages: 'Subir Imágenes',
            images: 'imágenes',
            maxImageSize: 'Máximo 5MB por imagen',
            validation: {
              nameRequired: 'El nombre del tour es obligatorio',
              descriptionRequired: 'La descripción es obligatoria para tours públicos',
              stockRequired: 'El límite de stock es obligatorio para tours públicos',
              priceRequired: 'El precio es obligatorio para tours públicos',
              meetingPointRequired: 'El punto de encuentro es obligatorio para tours públicos',
              includedRequired: 'Se requiere al menos un elemento incluido para tours públicos',
              notIncludedRequired: 'Se requiere al menos un elemento no incluido para tours públicos',
              tourDateRequired: 'La fecha del tour es obligatoria para tours públicos',
              availableDatesRequired: 'Se requiere al menos una fecha disponible para tours públicos',
              imagesRequired: 'Se requiere al menos una imagen para tours públicos',
              fixErrors: 'Por favor, corrija los errores antes de guardar',
              cannotMakePublic: 'Por favor, complete todos los campos requeridos antes de hacer público el tour'
            }
          },
          dashboard: {
            myTours: 'Mis Tours',
            createNewTour: 'Crear Nuevo Tour',
            paymentHistory: 'Historial de Pagos',
            backToDashboard: 'Volver al Panel',
            editProfile: 'Editar Perfil',
            uploadPhoto: 'Subir Foto',
            businessName: 'Nombre del Negocio',
            phone: 'Teléfono',
            description: 'Descripción',
            saveChanges: 'Guardar',
            cancel: 'Cancelar',
            deleteTour: {
              title: 'Eliminar Tour',
              message: '¿Estás seguro de que quieres eliminar este tour? Esta acción no se puede deshacer y toda la información asociada con este tour se perderá permanentemente.',
              confirm: 'Eliminar Tour',
              cancel: 'Cancelar'
            },
            tourVisibility: {
              public: 'Tour es público',
              private: 'Tour es privado'
            },
            tourDates: {
              dates: 'fechas',
              date: 'fecha'
            },
            notifications: {
              profileUpdateSuccess: 'Perfil actualizado exitosamente',
              profileUpdateError: 'Error al actualizar el perfil',
              tourDeleteSuccess: 'Tour eliminado exitosamente',
              tourDeleteError: 'Error al eliminar el tour',
              tourVisibilitySuccess: 'Visibilidad del tour actualizada',
              tourVisibilityError: 'Error al actualizar la visibilidad del tour',
              loadError: {
                profile: 'Error al cargar el perfil',
                tours: 'Error al cargar los tours',
                reports: 'Error al cargar los reportes de pago',
                reportDetails: 'Error al cargar los detalles del reporte'
              },
              imageUploadError: 'Error al subir la imagen',
              maxImagesError: 'Máximo {max} imágenes permitidas',
              imageUploadSuccess: 'Imágenes subidas exitosamente',
              imageRemoveSuccess: 'Imagen eliminada exitosamente'
            },
            paymentTable: {
              date: 'Fecha',
              transactions: 'Transacciones',
              duePayment: 'Pago Pendiente',
              status: 'Estado',
              actions: 'Acciones',
              viewDetails: 'Ver Detalles',
              processed: 'Procesado',
              pending: 'Pendiente'
            },
            paymentDetails: {
              title: 'Detalles del Reporte de Pago',
              customer: 'Cliente',
              tour: 'Tour',
              tourDate: 'Fecha del Tour',
              bookingDate: 'Fecha de Reserva',
              amount: 'Monto',
              status: 'Estado',
              summary: {
                totalAmount: 'Monto Total',
                managementFee: 'Cargo de Gestión (10%)',
                duePayment: 'Pago Pendiente'
              }
            }
          }
        }
      },
      publicItinerary: {
        scheduleTrip: 'Programar Viaje',
        createNewTrip: '＋ Crear Nuevo Viaje',
        tripOverview: 'Resumen del Viaje',
        showMore: 'Ver más',
        showLess: 'Ver menos',
        processingSubscription: 'Procesando tu suscripción...'
      },
      tourModal: {
        selectDate: 'Selecciona una fecha',
        bookTour: 'Reservar',
        included: 'Incluido',
        notIncluded: 'No Incluido',
        tips: 'Consejos',
        meetingPoint: 'Punto de Encuentro',
        spotsLeft: 'cupos disponibles',
        spotLeft: 'cupo disponible',
        noSpots: 'No hay cupos disponibles',
        showMore: 'Ver más',
        showLess: 'Ver menos',
        chooseDatePlaceholder: 'Elige una fecha',
        noAvailableDates: 'No hay fechas disponibles para este tour',
        soldOut: 'AGOTADO',
        completePayment: 'Completa tu Pago'
      },
      profile: {
        title: 'Mi Perfil',
        personalInfo: 'Información Personal',
        loading: 'Cargando perfil...',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        address: 'Dirección',
        country: 'País',
        locationNotSet: 'Ubicación no establecida',
        changePassword: 'Cambiar Contraseña',
        currentPassword: 'Contraseña Actual',
        newPassword: 'Nueva Contraseña',
        confirmPassword: 'Confirmar Nueva Contraseña',
        passwordError: {
          mismatch: 'Las nuevas contraseñas no coinciden',
          length: 'La nueva contraseña debe tener al menos 6 caracteres',
          same: 'La nueva contraseña debe ser diferente a la actual',
          generic: 'Error al cambiar la contraseña'
        },
        updateSuccess: 'Perfil actualizado exitosamente',
        updateError: 'Error al actualizar el perfil',
        passwordSuccess: 'Contraseña actualizada exitosamente',
        saveChanges: 'Guardar',
        cancel: 'Cancelar',
        edit: 'Editar',
        stats: {
          title: 'Estadísticas de Viaje',
          totalTrips: 'Total de Viajes',
          placesVisited: 'Lugares Visitados',
          hotelsBooked: 'Hoteles Reservados'
        },
        quickLinks: {
          favorites: 'Favoritos',
          bookings: 'Reservas',
          subscription: 'Suscripción',
          changePassword: 'Cambiar Contraseña'
        }
      },
      bookings: {
        title: 'Historial de Reservas',
        noBookings: 'No se encontraron reservas',
        loading: 'Cargando reservas...'
      },
      favorites: {
        title: 'Mis Favoritos',
        noFavorites: 'Aún no hay favoritos',
        loading: 'Cargando favoritos...'
      },
      tripDetails: {
        loading: 'Cargando...',
        title: 'Detalles del Viaje',
        budget: 'Presupuesto',
        checklist: 'Lista de Control',
        share: {
          title: 'Compartir Viaje',
          whatsapp: 'Compartir en WhatsApp',
          twitter: 'Compartir en X',
          email: 'Compartir por Correo',
          copy: 'Copiar enlace',
          privateMessage: 'Los viajes son privados por defecto, hazlo público en la configuración del viaje.'
        },
        confirmDelete: {
          title: 'Confirmar Eliminación',
          message: '¿Estás seguro de que quieres eliminar este viaje?',
          cancel: 'Cancelar',
          confirm: 'Eliminar'
        },
        confirmDeletePOI: {
          title: 'Eliminar {type}',
          message: '¿Estás seguro de que quieres eliminar "{name}"?',
          cancel: 'Cancelar',
          confirm: 'Eliminar'
        },
        unsavedChanges: {
          title: '¿Guardar?',
          message: '¿Quieres guardar los cambios realizados?',
          cancel: 'Cancelar',
          confirm: 'Guardar'
        },
        toast: {
          titleUpdated: 'Título actualizado exitosamente',
          titleError: 'Error al actualizar el título. Por favor, inténtalo de nuevo.',
          activityDateUpdated: 'Fecha de actividad actualizada exitosamente',
          activityDateError: 'Error al actualizar la fecha de la actividad. Por favor, inténtalo de nuevo.',
          activityAdded: '¡Actividad agregada al viaje exitosamente!',
          activityAddError: 'Error al agregar la actividad al viaje. Por favor, inténtalo de nuevo.'
        }
      },
      subscription: {
        title: 'Elige Tu Plan',
        free: {
          title: 'Gratis',
          price: '$0',
          perMonth: '/mes'
        },
        premium: {
          title: 'Premium',
          price: '$4.99',
          perMonth: '/mes',
          upgradeButton: 'Actualizar a Premium',
          currentPlan: 'Plan Actual',
          completeSubscription: 'Completa Tu Suscripción'
        },
        features: {
          allFreeFeatures: 'Todas las características gratuitas',
          unlimitedTrips: 'Crea viajes activos ilimitados',
          adFree: 'Experiencia sin anuncios',
          advancedBudget: 'Presupuesto de viaje con funciones avanzadas',
          offlineMaps: 'Mapas sin conexión y rutas de senderismo',
          noBookingFees: 'Sin cargos de reserva para hoteles recomendados',
          liveChat: 'Chat en vivo con locales',
          curated: 'Acceso a nuestra lista curada de lugares exclusivos para visitar',
          faq: 'Acceso a nuestras preguntas frecuentes e información del país',
          budget: 'Resumen del presupuesto del viaje',
          customActivities: 'Creación de actividades personalizadas para tu itinerario',
          hotelBookings: 'Reservas de hoteles recomendados (con cargo)',
          shareTrips: 'Comparte tus viajes',
          weather: 'Pronóstico del tiempo del día',
          language: 'Soporte en inglés y español'
        },
        status: {
          title: 'Estado de Suscripción: Premium',
          missingId: 'Tu ID de suscripción no está disponible. Esto puede suceder si te has actualizado recientemente.',
          currentId: 'ID de suscripción actual:',
          tryLogout: 'Por favor, intenta cerrar sesión y volver a iniciar sesión, o contacta a soporte si el problema persiste.'
        }
      },
      faq: {
        title: 'Guía del Viajero',
        subtitle: 'Todo lo que necesitas saber para tu aventura en República Dominicana.',
        searchPlaceholder: 'Buscar en la guía...',
        loading: 'Cargando...',
        noResults: 'No se encontró contenido de la guía que coincida con tu búsqueda.',
        error: 'Error: ',
        showMore: 'Ver Más'
      }
    },
    components: {
      tourModal: {
        selectDate: 'Selecciona una fecha',
        bookTour: 'Reservar',
        included: 'Incluido',
        notIncluded: 'No Incluido',
        tips: 'Consejos',
        meetingPoint: 'Punto de Encuentro',
        spotsLeft: 'cupos disponibles',
        spotLeft: 'cupo disponible',
        noSpots: 'No hay cupos disponibles',
        showMore: 'Ver más',
        showLess: 'Ver menos',
        chooseDatePlaceholder: 'Elige una fecha',
        noAvailableDates: 'No hay fechas disponibles para este tour',
        soldOut: 'AGOTADO',
        completePayment: 'Completa tu Pago'
      }
    },
    poi: {
      showMore: 'Mostrar más',
      showLess: 'Mostrar menos',
      addToTrip: 'Agregar al viaje',
      addToFavorites: 'Agregar a favoritos',
      removeFromFavorites: 'Quitar de favoritos',
      share: 'Compartir',
      recommendedHotels: 'Hoteles Recomendados',
      amenities: 'Servicios',
      address: 'Dirección',
      contact: 'Contacto',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      bookNow: 'Reservar ahora',
      pricePerNight: 'por noche',
      seeMoreDetails: 'Ver más detalles',
      seeLessDetails: 'Ver menos detalles',
      includesBookingFees: 'El precio incluye tasas e impuestos',
      backToPoi: 'Volver a',
      addToTripSuccess: '¡POI agregado al viaje exitosamente!',
      addToTripError: 'Error al agregar POI al viaje. Por favor, inténtalo de nuevo.',
      alreadyInTrip: 'Este POI ya está en el viaje seleccionado.',
      rooms: {
        availableRooms: 'Habitaciones Disponibles',
        maxGuests: 'Máximo de huéspedes',
        adults: 'adultos',
        perNight: 'por noche',
        beds: 'cama',
        beds_plural: 'camas',
        seeMoreDetails: 'Ver más detalles',
        seeLessDetails: 'Ver menos detalles',
        showLessAmenities: 'Mostrar menos',
        showMoreAmenities: '...',
      },
      hotelDetails: {
        amenities: 'Servicios',
        address: 'Dirección',
        contact: 'Contacto',
        phone: 'Teléfono',
        email: 'Correo electrónico',
      },
      recommendedHotels: 'Hoteles Recomendados',
      viewDetails: 'Ver Detalles',
      nearbyHotels: 'Hoteles Cercanos',
      nearbyPlaces: 'Lugares Cercanos',
      viewOnMap: 'Ver en el Mapa',
      howToGet: 'Cómo llegar',
      noDirections: 'No hay información disponible sobre cómo llegar aquí.'
    },
    common: {
      loading: 'Cargando...',
      error: 'Ha ocurrido un error',
      retry: 'Reintentar',
      close: 'Cerrar',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      update: 'Actualizar',
      yes: 'Sí',
      no: 'No',
      locale: 'es'
    },
    hotelBooking: {
      guestInfo: 'Información del Huésped',
      guest: 'Huésped',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      addToTrip: 'Agregar al Viaje',
      createNewTrip: 'Crear Nuevo Viaje',
      selectTrip: 'Seleccionar Viaje',
      tripDates: 'Fechas del Viaje',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      numberOfGuests: 'Número de Huéspedes',
      bookingSummary: 'Resumen de la Reserva',
      roomType: 'Tipo de Habitación',
      totalAmount: 'Monto Total',
      bookingFee: 'Cargo por Reserva',
      taxes: 'Impuestos',
      total: 'Total',
      paymentDetails: 'Completar su Reserva',
      premiumDiscount: 'Como miembro premium, puede completar su reserva sin cargos de reserva.',
      upgradeForDiscount: 'Actualiza a Premium para obtener 10% de descuento',
      upgradeToPremium: 'Actualizar a Premium',
      proceedToPayment: 'Completar Reserva',
      back: 'Atrás',
      next: 'Siguiente',
      sameAsTripDates: '¿Se hospedará en este hotel durante todo el viaje?',
      bookingSuccess: '¡Reserva Exitosa!',
      viewBooking: 'Ver Reserva',
      required: 'Requerido',
      invalidEmail: 'Correo electrónico inválido',
      invalidPhone: 'Número de teléfono inválido',
      selectTripFirst: 'Por favor seleccione un viaje primero',
      guestCountError: 'El número de huéspedes excede la capacidad máxima de las habitaciones seleccionadas. Por favor, agregue más habitaciones.',
      termsAgreement: 'Entiendo que el cargo por reserva no es reembolsable y acepto los',
      termsOfService: 'términos de servicio',
      bookingFeeMessage: 'Por favor complete su pago para confirmar su reserva. Se le cobrará',
      dueAtPropertyMessage: 'El monto restante se pagará en la propiedad',
      loadingPayment: 'Cargando PayPal...',
      paymentWindowError: 'Ventana de pago ya está abierta',
      paypalError: 'Error al cargar PayPal. Por favor, actualice la página e intente nuevamente.',
      processingBooking: 'Procesando su reserva...',
      paymentWindowClosed: 'La ventana de pago se cerró. Por favor intente nuevamente.',
      tripTo: 'Viaje a',
      checkInAt: 'Entrada en',
      checkOutFrom: 'Salida de',
      dueAtProperty: 'A pagar en la propiedad'
    },
    auth: {
      welcomeBack: "Bienvenido de nuevo",
      createAccount: "Crea tu cuenta",
      signIn: "Iniciar sesión",
      signUp: "Registrarse",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo electrónico",
      password: "Contraseña",
      noAccount: "¿No tienes una cuenta? Regístrate",
      haveAccount: "¿Ya tienes una cuenta? Inicia sesión",
      forgotPassword: "¿Olvidaste tu contraseña?",
      forgotPasswordMailSubject: "Solicitud de contraseña temporal — Quisqueya Quest",
      forgotPasswordMailBody:
        "Hola,\n\nMe gustaría solicitar una contraseña temporal para mi cuenta de Quisqueya Quest.\n\nGracias.",
      close: "Cerrar",
      errors: {
        default: "Ocurrió un error inesperado. Por favor, inténtalo de nuevo.",
        invalidCredentials: "Correo electrónico o contraseña inválidos",
        emailExists: "Ya existe una cuenta con este correo electrónico",
        required: "Este campo es obligatorio",
        invalidEmail: "Por favor, introduce un correo electrónico válido"
      }
    },
    customActivity: {
      title: 'Crear Actividad Personalizada',
      editTitle: 'Editar Actividad',
      activityDetails: 'Detalles de la Actividad',
      name: 'Nombre',
      type: 'Tipo',
      description: 'Descripción',
      duration: 'Duración',
      hours: 'hora(s)',
      location: 'Ubicación',
      addLocation: '¿Agregar ubicación?',
      price: 'Precio',
      optional: 'opcional',
      saveChanges: 'Guardar',
      saveActivity: 'Guardar Actividad',
      types: {
        task: 'Tarea',
        hotel: 'Hotel',
        exploration: 'Exploración',
        rent_a_car: 'Alquiler de Auto',
        restaurant: 'Restaurante',
        poi: 'Punto de Interés',
        select: 'Seleccionar tipo de actividad'
      },
      validation: {
        nameRequired: 'El nombre es requerido',
        typeRequired: 'El tipo de actividad es requerido'
      },
      updateSuccess: 'Actividad actualizada exitosamente',
      updateError: 'Error al actualizar la actividad'
    },
    budget: {
      title: 'Presupuesto del Viaje',
      overview: 'Resumen',
      advancedSettings: 'Configuración Avanzada',
      totalBudget: 'Presupuesto Total',
      budgetAlerts: 'Alertas de Presupuesto',
      selectDay: 'Seleccionar Día',
      selectType: 'Seleccionar Tipo de Actividad',
      limit: 'Límite',
      set: 'Establecer',
      delete: 'Eliminar',
      confirmDelete: {
        title: 'Eliminar Límite de Presupuesto',
        message: '¿Estás seguro de que quieres eliminar este límite de presupuesto?'
      },
      premiumFeature: {
        title: 'Las alertas de presupuesto son una función premium',
        upgrade: 'Actualizar a Premium'
      },
      includes: 'El precio incluye tasas e impuestos'
    },
    checklist: {
      title: 'Lista de Control',
      addNew: 'Agregar nuevo elemento',
      deleteConfirm: {
        title: 'Eliminar Elemento',
        message: '¿Estás seguro de que quieres eliminar este elemento?'
      },
      defaultItems: {
        passport: 'Pasaporte y tarjeta de turista',
        sunscreen: 'Protector solar y repelente de mosquitos',
        beach: 'Elementos esenciales para la playa (traje de baño, toallas)',
        shoes: 'Zapatos cómodos para caminar',
        money: 'Efectivo y tarjetas de crédito'
      }
    },
    subscription: {
      title: 'Elige Tu Plan',
      free: {
        title: 'Gratis',
        price: '$0',
        perMonth: '/mes'
      },
      premium: {
        title: 'Premium',
        price: '$4.99',
        perMonth: '/mes',
        upgradeButton: 'Actualizar a Premium',
        currentPlan: 'Plan Actual',
        completeSubscription: 'Completa Tu Suscripción'
      },
      features: {
        allFreeFeatures: 'Todas las características gratuitas',
        unlimitedTrips: 'Crea viajes activos ilimitados',
        adFree: 'Experiencia sin anuncios',
        advancedBudget: 'Presupuesto de viaje con funciones avanzadas',
        offlineMaps: 'Mapas sin conexión y rutas de senderismo',
        noBookingFees: 'Sin cargos de reserva para hoteles recomendados',
        liveChat: 'Chat en vivo con locales',
        curated: 'Acceso a nuestra lista curada de lugares exclusivos para visitar',
        faq: 'Acceso a nuestras preguntas frecuentes e información del país',
        budget: 'Resumen del presupuesto del viaje',
        customActivities: 'Creación de actividades personalizadas para tu itinerario',
        hotelBookings: 'Reservas de hoteles recomendados (con cargo)',
        shareTrips: 'Comparte tus viajes',
        weather: 'Pronóstico del tiempo del día',
        language: 'Soporte en inglés y español'
      },
      status: {
        title: 'Estado de Suscripción: Premium',
        missingId: 'Tu ID de suscripción no está disponible. Esto puede suceder si te has actualizado recientemente.',
        currentId: 'ID de suscripción actual:',
        tryLogout: 'Por favor, intenta cerrar sesión y volver a iniciar sesión, o contacta a soporte si el problema persiste.'
      }
    },
    faq: {
      title: 'Guia del Viajero',
      subtitle: 'Todo lo que necesitas saber para tu aventura en República Dominicana.',
      searchPlaceholder: 'Buscar en la guía...',
      loading: 'Cargando...',
      noResults: 'No se encontró contenido de la guía que coincida con tu búsqueda.',
      error: 'Error: ',
      showMore: 'Ver Más'
    }
  }
}; 